export default __webpack_public_path__ + "static/media/pumpkin-l1.536f47cb.webp";